<div class="warp-question" #formQuestion>
  <div class="question-form">
    <div class="header">
      <div class="right">
        <que-title-question queDisplayByType [name]="'texts'" [typeId]="myType" [formControl]="titleAndText"
          [index]="index" [question]="this.questionForm.value"></que-title-question>
        <que-big-title-question queDisplayByType [name]="'title'" [typeId]="myType" [formControl]="titleAndText"
          [index]="index" [question]="this.questionForm.value"></que-big-title-question>
      </div>
      <que-display-api-field-name *ngIf="apiExposureFieldSig$() as field"
        [name]="'grid.categoryName' | translate: { category: { name: field.fieldName, enName: field.fieldNameEn } }"></que-display-api-field-name>
      <que-display-auto-fill-field *ngIf="autoFillFieldSig$() as field"
        [name]="field.displayName"></que-display-auto-fill-field>
      <que-smart-tooltip *ngIf="questionForm.value?.collectionQuestionId"></que-smart-tooltip>
    </div>
    <div queDisplayByType [name]="'line'" [typeId]="myType" class="line"></div>
    <que-question-form queDisplayByType [name]="'form'" [typeId]="myType"
      [formControl]="questionForm"></que-question-form>
  </div>
  <div class="warp-menu">
    <que-menu-question queDisplayByType [name]="'menu'" [typeId]="myType" [question]="questionForm.value"
      (eventMenu)="eventMenu($event)">
    </que-menu-question>
    <!-- <que-toggle queDisplayByType [name]="'required'" [typeId]="myType" (toggleEvent)="toggleRequierd($event)" [toggleState]="questionForm.value?.requierd??false" [isMenu]="true"></que-toggle> -->
    <que-toggle *ngIf="!questionForm.value?.parentFollowUpQuestionId" (toggleEvent)="toggleRequierd($event)"
      queDisplayByType [name]="'toggle'" [typeId]="myType" [toggleState]="questionForm.value?.requierd ?? false"
      [isMenu]="true"></que-toggle>
    <div class="pointer" (click)="duplicateQuestion()">
      <img src="/assets/images/question-menu/duplicate.svg" />
    </div>
    <div class="pointer" (click)="deleteMeEvent.emit()">
      <svg-icon class="icon" svgClass="icon-close" src="/assets/images/question-menu/delete.svg"></svg-icon>
    </div>
  </div>
</div>